import { capitalizeEachFirstLetter, capitalizeFirstLetter } from '../../../utils/stringUtils';
import { InputField } from '../../../components/InputFields/InputField';
import './CustomerAndDeviceInfo.css'
import { useState } from 'react';
import { SaveIcon } from '../../../assets/svg/SaveIcon';
import { EditIcon } from '../../../assets/svg/EditIcon';
import ClaimService from '../../../services/claims/claimService';
import { useAuthState } from '../../../contexts/Auth/context';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import AppToaster, { ToastType } from '../../../components/AppToaster/AppToaster';
import { ToasterId } from '../../../enums/ToasterIds';

interface ICustomerAndDeviceInfo {
  data: any;
  fetchData?: () => void;
  claimId?: string;
}

const CustomerAndDeviceInfo = ({ data: { customer, policy, device, paymentHistory, claim }, fetchData, claimId }: ICustomerAndDeviceInfo) => {
  const { token } = useAuthState();
  const bearerToken = `${capitalizeFirstLetter(token?.type)} ${token?.token}`;
  const [isEditing, setIsEditing] = useState(false);
  const [repairCost, setRepairCost] = useState(claim?.repairCost || '');
  const [displayRepairCost, setDisplayRepairCost] = useState(formatCurrency(claim?.repairCost || ''));
  const [hasChanges, setHasChanges] = useState(false);
  const isClaimPage = useLocation().pathname.includes('claim');

  function formatCurrency(value: string | number): string {
    if (!value) return '$0.00';
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue);
  }

  function parseCurrencyValue(formattedValue: string): string {
    return formattedValue.replace(/[^0-9.]/g, '');
  }

  const handleEditClick = () => {
    setIsEditing(true);
    // Story 1462 -- change disabled
    // setDisplayRepairCost(repairCost);
  };

  const handleSaveClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!hasChanges) {
      setIsEditing(false);
      return;
    }

    try {
      const response = await ClaimService.updateRepairCost(parseInt(claimId ?? '0'), repairCost, bearerToken);
      
      setIsEditing(false);
      setHasChanges(false);
      // Story 1462 -- change disabled
      // setDisplayRepairCost(formatCurrency(repairCost));
      
      if (fetchData) {
        fetchData();
      }

      toast.custom(
        <AppToaster 
          type={ToastType.SUCCESS} 
          id={ToasterId.UpdateClaimSuccess} 
          message="Repair cost updated successfully"
        />, 
        { id: ToasterId.UpdateClaimSuccess, duration: 5000 }
      );
    } catch (error) {
      setRepairCost(claim?.repairCost || '');
      // Story 1462 -- change disabled
      // setDisplayRepairCost(formatCurrency(claim?.repairCost || ''));
      setIsEditing(false);
      setHasChanges(false);
      toast.custom(
        <AppToaster 
          type={ToastType.ERROR} 
          id={ToasterId.UpdateClaimError} 
          message="Failed to update repair cost"
        />, 
        { id: ToasterId.UpdateClaimError, duration: 5000 }
      );
    }
  };

  const onBlur = () => {
    if (!hasChanges) {
      setIsEditing(false);
      // Story 1462 -- change disabled
      // setDisplayRepairCost(formatCurrency(repairCost));
    }
  }

  const handleRepairCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setRepairCost(newValue);
    // Story 1462 -- change disabled
    // setDisplayRepairCost(newValue);
    setHasChanges(newValue !== claim?.repairCost);
  };

  return (
    <div className='customer-and-device-container'>
      <div className='policy-customer-info'>
        <div className="customer-and-device-heading">
          <p>Customer</p>
        </div>

        <div className='policy-details'>
          <div>
            <p className='label'>Name</p>
            <p className='info'>{capitalizeEachFirstLetter(customer.fullName)}</p>
          </div>
          <div>
            <p className='label'>Email</p>
            <p className='info'>{customer.email || 'No email found'}</p>
          </div>
          <div>
            <p className='label'>Trn</p>
            <p className='info'>{customer.trn || 'No trn found'}</p>
          </div>
          <div>
            <p className='label'>Phone Number</p>
            <p className='info'>{customer.phone || 'No number found'}</p>
          </div>
        </div>
      </div>

      <div className='policy-device-info'>
        <div className="customer-and-device-heading">
          <p>Device</p>
        </div>

        <div className='policy-details'>
          <div>
            <p className='label'>Model</p>
            <p className='info'>{device.phoneMake} {device.phoneModel}</p>
          </div>
          <div>
            <p className='label'>Color</p>
            <p className='info'>{device.phoneColor}</p>
          </div>
          <div>
            <p className='label'>IMEI</p>
            <p className='info'>{policy.imei}</p>
          </div>
        </div>

        {/* story-1454 - change disabled */}
        {/* {isClaimPage && (
          <div className='policy-details claim-repair__cost-container'>
            <div className='claim-repair__cost'>
              <p className='label'>Repair Cost</p>
              <div className='repair-cost__input-container'>
                <InputField
                  type='number'
                  value={repairCost}
                  // Story 1462 -- change disabled
                  // type='text'
                  // value={isEditing ? displayRepairCost : formatCurrency(repairCost)}
                  onChange={handleRepairCostChange}
                  isReadOnly={!isEditing}
                  inputContainerStyles='container-icon'
                  onBlur={onBlur}
                />
                <div 
                  className={`repair-cost__icon ${hasChanges ? 'has-changes' : ''}`}
                  onClick={isEditing ? handleSaveClick : handleEditClick}
                >
                  {isEditing ? <SaveIcon /> : <EditIcon />}
                </div>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default CustomerAndDeviceInfo